import { saveAs } from 'file-saver'
import $http from '@/libs/axios'
import FormsService from '@/services/forms-service'

export default class InventoryItemAPI {
  static async process(payload: any) {
    return (await $http.post('/inventory/items', payload)).data
  }

  static async exportItemsCountExcel(branchId: any, filters?: any) {
    const url = `/inventory/items/export/items-counts/${branchId}?${FormsService.prepareQueryString(filters, true)}`
    const file = (await $http.get(url, { responseType: 'blob' })).data
    saveAs(file, 'items-counts.xlsx')
  }

  static async exportIngredientsExcel(branchId: any, filters: any, isRecipe: boolean) {
    const url = `/inventory/items/export/xlsx?${isRecipe ? 'price_type=fixed' : 'price_type=ingredient'}&${FormsService.prepareQueryString(filters, true)}`
    const file = (await $http.get(url, { responseType: 'blob' })).data
    saveAs(file, `${!isRecipe ? 'Recipes' : 'Ingredients'}.xlsx`)
  }

  static async updateSuppliers(payload: any) {
    return (await $http.post('/inventory/item/update-supplier', payload)).data
  }

  static async delete(unitId: any) {
    return (await $http.delete(`/inventory/items/${unitId}`)).data
  }

  static async getById(unitId: any) {
    return (await $http.get(`/inventory/items/${unitId}`)).data
  }

  static async getDependencies() {
    return (await $http.get('/inventory/item/dependencies')).data
  }

  static async generateSku() {
    return (await $http.get('/inventory/item/sku')).data
  }

  static async listByPriceLabels(payload: any) {
    return (await $http.post('/inventory/item/by-prices', payload)).data
  }

  static async list(query = null) {
    let url = '/inventory/items'
    if (query) url += `?${query}`
    return (await $http.get(url)).data
  }

  static async import(body: any, type: string) {
    const headers = { 'Content-Type': 'multipart/form-data' }
    return (await $http.post(`inventory/import/${type}`, body, { headers })).data
  }

  static async getTemplate(type: string) {
    const file = (await $http.get(`inventory/export/${type}`, { responseType: 'blob' })).data
    const t = type.split('?')[0] ?? type
    return saveAs(file, `${t}-template.xlsx`)
  }
}
